// routing
import Routes from 'routes';

// project imports
import NavigationScroll from 'layout/NavigationScroll';
import { Toaster } from 'react-hot-toast';
import ThemeCustomization from 'themes';
import Locales from 'ui-component/Locales';
import RTLLayout from 'ui-component/RTLLayout';
import Snackbar from 'ui-component/extended/Snackbar';
import ApiLoadingOverlay from 'ui-component/ApiLoadingOverlay';
import SessionExpiredHandler from 'ui-component/SessionExpiredHandler';

// auth provider

// ==============================|| APP ||============================== //

const App = () => (
  <ThemeCustomization>
    {/* RTL layout */}
    <RTLLayout>
      <Locales>
        <NavigationScroll>
          <>
            <Toaster />
            <ApiLoadingOverlay />
            <SessionExpiredHandler />
            <Routes />
            <Snackbar />
          </>
        </NavigationScroll>
      </Locales>
    </RTLLayout>
  </ThemeCustomization>
);

export default App;
